export default "__VITE_ASSET__tl8mqQN8__"